module.exports = __webpack_public_path__ + "img/WP2023-SoMe-1200x630.16e3e198.png";